<template>
  <div class="attributes_wrap">
    <el-form
        :model="formAttributes"
        ref="form"
        label-position="top"
    >
        <div class="attributes_list flex wrap">
            <div 
                class="attributes_item" 
                v-for="(item) in attrList"
                :key="item.id"
            >
                <el-form-item
                    :label="item.attrName" 
                    :prop="item.id+''"
                >
                    <el-select v-if="[1,2,3].includes(item.elementType)" v-model="formAttributes[item.id]" :multiple="item.elementType === 3" placeholder="请选择" width="100%">
                        <el-option v-for="v in item.attributeValues" :label="v.valueName" :value="v.key" :key="v.key"></el-option>
                    </el-select>
                    <el-input v-else-if="item.elementType === 4" v-model="formAttributes[item.id]" width="100%" placeholder="请输入内容"></el-input>
                    <el-input v-else-if="item.elementType === 5" type="textarea" v-model="formAttributes[item.id]" width="100%" :rows="2" placeholder="请输入内容"></el-input>
                    <el-input-digit v-else-if="item.elementType === 6" v-model.number="formAttributes[item.id]" placeholder="请输入" :precision="2" style="width: 100%"/>
                    <el-date-picker v-else-if="item.elementType === 7" v-model="formAttributes[item.id]" type="year" placeholder="请选择"></el-date-picker>
                    <el-date-picker v-else-if="item.elementType === 8" v-model="formAttributes[item.id]" type="month" placeholder="请选择"></el-date-picker>
                    <el-date-picker v-else-if="item.elementType === 9" v-model="formAttributes[item.id]" type="date" placeholder="请选择"></el-date-picker>
                </el-form-item>
            </div>
        </div>
    </el-form>
  </div>
</template>
<script>
// import { getJdmsCategoryProps } from '@/servers/prod/center/jdms.js';
export default {
  components: {

  },
  props: {
    formData:{
        type: Object,
        default: () => {
            return {};
        }
    },
    // 所有属性
    attrList:{
        type:Array,
        default:()=>{
            return []
        }
    },
  },
  data() {
    return {
        formAttributes:{},
        // 属性映射
        attrListMap:{},
        rules: {},
    };
  },
  watch: {
    attrList:{
        handler(v){
            if(v){
                this.initAttr(v);
                // let map = {}
                // v.forEach(item => {
                //     map[item.id] = item
                // })
                // this.$set(this,'attrListMap',map)
            }
        },
        immediate: true
    },
  },
  computed: {
    shopId() {
      return this.$store.getters.shops_getCategoryPropShopId('shein')
    },
  },

  methods: {
    getAttrData(){
        let list = [];
        for(let key in this.formAttributes){
            let value = this.formAttributes[key];
            if(value && Array.isArray(value)){
                value.forEach(k => {
                    let obj = {
                        key:key,
                        valueName:k
                    }
                    list.push(obj)
                })
            }else{
                if(value){
                    let obj = {
                        key:key,
                        valueName:value
                    }
                    list.push(obj)
                }
            }
        }
        return list;
    },
    initAttr(list){
        let map = {};
        list.forEach(item => {
            map[item.id] = item
        })
        this.$set(this,'attrListMap',map)

        let categoryAttrs = this.formData.categoryAttrs
        let valueMap = {}
        categoryAttrs.forEach(item => {
            let id = item.key
            let name = item.valueName
            if(map[id]){
                let value = valueMap[id]
                if(value){// 兼容多选的情况
                    if(Array.isArray(value)){
                        valueMap[id] = [...value,name]
                    }else{
                        valueMap[id] = [value,name]
                    }
                }else{ // 非多选
                    valueMap[id] = name
                }
            }
        })
        this.$set(this, 'formAttributes', valueMap);
    },
    valid() {
        // return new Promise((resolve) => {
        //     this.$nextTick(() => {
        //         this.$refs.form.validate(valid => {
        //             resolve(valid);
        //         })
        //     })
        // })
    },
  },
  created(){
  },
  mounted() {
   
  },
};
</script>

<style lang="scss" scoped>
.attributes_wrap{
    padding: 10px;
    background: #fafafa;
    .attributes_item{
        width: 50%;
        padding: 0 10px;
    }
    ::v-deep .el-form--label-top{
        .el-form-item__label{
            padding: 0 !important;
        }
    }
}
</style>
